import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { VigenciaBandeiraShow } from '../../components'
import * as vigenciaBandeiraActionCreators from '../../redux/modules/vigenciaBandeira'

class VigenciaBandeiraShowContainer extends Component {

  static propTypes = {
    id: PropTypes.string,
    history: PropTypes.object,
    fetchVigenciaBandeira: PropTypes.func,
    destroyVigenciaBandeira: PropTypes.func,
  }

  state = {
    vigenciaBandeira: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const vigenciaBandeira = await this.props.fetchVigenciaBandeira(this.props.id)
      this.setState({ vigenciaBandeira })
    }
  }

  handleRedirectToNew = () => {
    this.props.history.push('/gestao_bandeiras/vigencias/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/gestao_bandeiras/vigencias/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyVigenciaBandeira(id)
    this.props.history.push('/gestao_bandeiras/vigencias')
  }

  render () {
    return (
      <VigenciaBandeiraShow
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        vigenciaBandeira={this.state.vigenciaBandeira} />
    )
  }
}

function mapStateToProps ({vigenciaBandeira}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      vigenciaBandeira: vigenciaBandeira.get('id'),
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...vigenciaBandeiraActionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(VigenciaBandeiraShowContainer)
